import { Component, OnInit, AfterViewInit, Renderer2, ElementRef, EventEmitter, Output } from '@angular/core';
import { ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, Validators, FormArray } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { DataService } from 'src/app/blacklist/service/data.service';
import { BackendApiService } from 'src/app/service/backendapi.service';
import { EndpointsService } from 'src/app/service/endpoints.service';
import { DeleteCampaignDialogComponent } from '../delete-campaign-dialog/delete-campaign-dialog.component';
import { DataTableDirective } from 'angular-datatables';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { AddCampaignComponent } from './add-campaign/add-campaign.component';



@Component({
  selector: 'app-campaign',
  templateUrl: './campaign.component.html',
  styleUrls: ['./campaign.component.scss']
})
export class CampaignComponent implements OnInit {
  showTable: boolean;
  campaignForm: FormGroup;
  campaignGroup: FormGroup;
  public sessionStorage = sessionStorage;
  @Output() refreshTableData = new EventEmitter();
  // @ViewChild('ModalDirective','') modal: ModalDirective;
  @ViewChild('closebutton', { static: true }) closeButton: ElementRef;

  closeResult: string;
  subcriberTypemapping = {
    '1': 'Prepaid',
    '2': 'Postpaid',
    '3': 'Standard'
  };
  eventTypeMapping = {
    '1': 'GSM UL',
    '2': 'GSM CL',
    '3': 'GPRS UL',
    '4': 'GPRS CL'
  }
  messageMapping = {
    '1': 'EN',
    '2': 'FR',
    '3': 'SP',
    '4': 'PO'
  }
  tadigMapping = {
    '1': 'All',
    '2': 'TADIG1',
    '3': 'TADIG2',
    '4': 'TADIG3'
  }
  countryMapping = {
    '1': 'All',
    '2': 'India',
    '3': 'USA'
  }
  affiliatesMapping = {
    '1': 'All',
    '2': 'Affiliates1',
    '3': 'Affiliates2',
    '4': 'Affiliates3'
  }
  withTadigMapping = {
    '': 'All',
    '2': 'WithTadig1',
    '3': 'WithTadig2',
    '4': 'WithTadig3'
  }
  VPMNCountryMapping = {
    '1': 'All',
    '2': 'India',
    '3': 'USA'
  }
  roamingPartnersMapping = {
    '1': 'All',
    '2': 'Partners1',
    '3': 'Partners2',
    '4': 'Partners3'
  }

  tableData = [];
  callVPMNNetwork: boolean;
  campaignData = [];
  campaignData1 = [];
  campaignData2 = [];
  campaignData3 = [];
  campaignData4 = [];
  HPMNCountry: [];
  HPMNNetwork: [];
  HPMNTadig: [];
  campaignId = [];
  isCamapaignEdit = false;
  isCampaignView = true;
  editIndex = null;
  uniqueArray: any = [];
  template: String;
  type = 'home'
  // We use this trigger because fetching the list of persons can be quite long,
  // thus we ensure the data is fetched before rendering

  //miltiselect dropdown
  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};
  isSuperUser: boolean;

  constructor(private modalService: NgbModal,
    private formBuilder: FormBuilder, private spinnerService: Ng4LoadingSpinnerService, private dataService: DataService,
    private router: Router, private endpointsService: EndpointsService, private dialog: MatDialog,
    private backendApiService: BackendApiService,
    private renderer: Renderer2) { }

  

  ngOnInit() {
    this.isSuperUser = Boolean(sessionStorage.getItem("isSuperUser")==="true");
    this.tableData = this.getData();
    this.renderer.removeClass(document.body, 'businessModel');
    this.renderer.removeClass(document.body, 'communityModel');
    this.renderer.addClass(document.body, 'campaignModel');
    this.createCampaignGroup();
    this.getApiOnLoad();
    
  }
  createCampaignGroup()
  {
    this.campaignGroup = this.formBuilder.group({
    hpmnCountry: [''],
    hpmnNetwork: [''],
    hpmnTadig: [''],
    vpmnTadig: [''],
    vpmnCountry: [''],
    vpmnNetwork: [''],
    campaignId: ['']
  })}

 
  getData() {
    var data = localStorage.getItem('campaignData');
    if (!data) {
      return [];
    }
    return JSON.parse(data);
  }

  open() {
    const dialogRef = this.dialog.open(AddCampaignComponent, {
      height:'600px',
      data: { type: 'Creation' },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed : ' + result);
      this.refreshTableData.emit();
    });

  }

  getApiOnLoad() {
    this.spinnerService.show();
    const apiUrl = this.endpointsService.URL_GET_CAMPAIGN + '&userName=' + sessionStorage.getItem('ecowas_user_name');

    this.backendApiService.callToApi(apiUrl).subscribe(response => {
      this.campaignData = response;
    });
    this.getCountry();
  }

  async getCountry() {
    this.spinnerService.show();
    const apiUrl = this.endpointsService.COUNTRY_DETAILS + '&userName=' + sessionStorage.getItem('ecowas_user_name');
    this.backendApiService.callToApi(apiUrl).subscribe(response => {
      this.campaignData1 = response;
    });
    // const apiUrl = this.endpointsService.URL_GET_CAMPAIGN_COUNTRY + '&type=home';
    // this.backendApiService.callToApi(apiUrl).subscribe(response => {
    //   this.campaignData1 = response;
    // });

  }

  getVpmnNetworkAccordingToCountry(event: any) {
    if (event.target && event.target.value === '1') {
      this.callVPMNNetwork = false;
      this.campaignForm.controls.roamingPartners.setValue('1', { onlySelf: true });
    } else {
      this.spinnerService.show();
      if (event.target) {
        this.getVpmnNetworkList(event.target.value).then();
      } else {
        this.getVpmnNetworkList(event).then();
      }
    }
  }
  getVpmnNetworkAccordingToCountry1(event: any) {
    if (event.target && event.target.value === '1') {
      this.callVPMNNetwork = false;
      this.campaignForm.controls.vpmnNetwork.setValue('1', { onlySelf: true });
    } else {
      this.spinnerService.show();
      if (event.target) {
        this.getVpmnNetworkList1(event.target.value).then();
      } else {
        this.getVpmnNetworkList1(event).then();
      }
    }
  }

  async getVpmnNetworkList1(country: string) {
    const apiUrl1 = this.endpointsService.URL_GET_OPERATOR_LIST_BY_COUNTRY +
      '&userName=' + sessionStorage.getItem('ecowas_user_name') + '&country=' + country;
    this.backendApiService.callToApi(apiUrl1).subscribe(response => {
      this.campaignData2 = response;
      if (this.campaignData2 && this.campaignData2.length > 0) {
        this.campaignGroup.controls.vpmnNetwork.setValue(response[0].operator, { onlySelf: true });
      }
      this.getVpmnTadig1();
    });
  }
  
  async getVpmnNetworkList(country: string) {   
    this.campaignData2 = await this.backendApiService.callToApi(this.endpointsService.URL_GET_OPERATOR_LIST_BY_COUNTRY +
      '&userName=' + sessionStorage.getItem('ecowas_user_name') + '&country=' + country)
      .toPromise();

    if (this.campaignData2 === null) {
      alert('api response null. please contact administrator');
      return;
    } else {
      this.spinnerService.hide();
      if (this.campaignData2.length !== 0) {
        this.campaignForm.controls.roamingPartners.
          setValue(this.campaignData2[0].operator);
          this.getVpmnTadig();
        this.callVPMNNetwork = true;
      } else {
        this.callVPMNNetwork = false;
      }
      return;
    }
  }

  getHpmnNetworkAccordingToCountry(event: any) {
    if (event.target.value === '1') {
      this.callVPMNNetwork = false;
      this.campaignForm.controls.vpmnNetwork.setValue('1', { onlySelf: true });
    } else {
      this.spinnerService.show();
      this.getHpmnNetworkList(event.target.value).then();
    }
  }

  async getHpmnNetworkList(country: string) {
    const apiUrl1 = this.endpointsService.URL_GET_OPERATOR_LIST_BY_COUNTRY +
      '&userName=' + sessionStorage.getItem('ecowas_user_name') + '&country=' + country;
    this.backendApiService.callToApi(apiUrl1).subscribe(response => {
      this.HPMNNetwork = response;
    });
    //this.getTadig();
    this.getHpmnTadig();
  }

  getHpmnTadig() {
    this.backendApiService.callToApi(
      this.endpointsService.URL_GET_CAMPAIGN_TADIG + '&country=' + this.campaignGroup.get('hpmnCountry').value +
      '&operator=' + this.campaignGroup.get('hpmnNetwork').value).
      subscribe(response => {
        if (response.length === 0) {
          return;
        }
        this.HPMNTadig = response;
        // this.searchRetailDB.get('vpmnTadig')
        //   .setValue(response[0].tapCode, {onlySelf: true});
      });
  }
  getVpmnTadig() {
    this.backendApiService.callToApi(
      this.endpointsService.URL_GET_CAMPAIGN_TADIG + '&country=' + this.campaignForm.get('rCountry').value +
      '&operator=' + this.campaignForm.get('roamingPartners').value).
      subscribe(response => {
        if (response.length === 0) {
          return;
        }
        this.campaignData3 = response;
        this.campaignForm.get('withTadig')
          .setValue(response[0].tapCode, {onlySelf: true});
      });
  }
  getVpmnTadig1() {
    if(this.campaignGroup.controls.vpmnCountry.value == "" || this.campaignGroup.controls.vpmnNetwork.value == ""){
      this.campaignData4 = [];
      this.campaignGroup.get('vpmnTadig')
          .setValue("", {onlySelf: true});
    }
    else{
    this.backendApiService.callToApi(
      this.endpointsService.URL_GET_CAMPAIGN_TADIG + '&country=' + this.campaignGroup.get('vpmnCountry').value +
      '&operator=' + this.campaignGroup.get('vpmnNetwork').value).
      subscribe(response => {
        if (response.length === 0) {
          return;
        }
        this.campaignData4 = response;
        this.campaignGroup.get('vpmnTadig')
          .setValue(response[0].tapCode, {onlySelf: true});
      });
    }
  }
  
  get allEvents() {
    return this.campaignForm.get('events') as FormArray;
  }
  get allMessages() {
    return this.campaignForm.get('msgContent') as FormArray;
  }
  ///////////End ////////////////
  triggerClick() {
    let el: HTMLElement = this.closeButton.nativeElement as HTMLElement;
    el.click();
  }
  addEvents() {
    this.allEvents.push(
      this.formBuilder.group(
        {
          subcriberType: [],
          previousVisit: [],
          eventType: [],
          stayDuration: [],
          currentLocation: [],
          messageId: [],
          rta: [],
          previousValue: []
        }));
    this.allMessages.push(
      this.formBuilder.group(
        {
          messageId:[],
          msgLanguage: [],
          messageContent: [],
          rtaMessageText: [],
          rtaMessageLanguage: []
        }));
  }

  deleteEvents(index) {
    this.allEvents.removeAt(index);
    this.allMessages.removeAt(index);
  }

  changeDateEvent(targetCalendarId: any) {
    targetCalendarId.toggle();
  }


  onSearch() {
    this.spinnerService.show();
    this.showTable = false;
    const apiUrl = this.endpointsService.URL_GET_CAMPAIGN_TABLE +
      '&userName=' + sessionStorage.getItem('ecowas_user_name') + '&hpmnTadIg=' + this.campaignGroup.get('hpmnTadig').value +
      '&hpmnCountry=' + this.campaignGroup.get('hpmnCountry').value + '&hpmnNetwork=' + this.campaignGroup.get('hpmnNetwork').value +
      '&vpmnTadIg=' + this.campaignGroup.get('vpmnTadig').value + '&vpmnNetwork=' + this.campaignGroup.get('vpmnNetwork').value +
      '&vpmnCountry=' + this.campaignGroup.get('vpmnCountry').value + '&userOrgId=' + sessionStorage.getItem('userOrgId')
    '&&campaingId=' + this.campaignGroup.get('campaignId').value;
    

    this.backendApiService.callToApi(apiUrl).subscribe(response => {
      if (response === null)
        return;

      this.campaignData = response;
      


      this.showTable = true;
      this.spinnerService.hide();
    });


  }

  onReset() {
    this.spinnerService.show();
    this.showTable = false;
    this.createCampaignGroup();
  }

}
